import { useEffect, useState } from "react";
import { DKLabel, DKIcon,DKIcons, DKInput, DKCheckMark,INPUT_VIEW_DIRECTION, DKButton,showToast,removeLoader,showLoader,showAlert, TOAST_TYPE } from 'deskera-ui-library';
import ic_drag from "../../assets/icons/ic_drag.png";
import { INPUT_TYPE } from "../../constants/Constant";
import Utility, { deepClone } from "../../utility/Utility";
import AppraisalManager from './AppraisalManager'
import PerformaceService from "../../services/PerformaceService";
import { useTranslation } from "react-i18next";
import moment from "moment";
function AppraisalCycleQuestions(props) {

    
    const { t } = useTranslation();
    const [sequence, setSequence] = useState([]);
    const [canValidate, setValidate] = useState(false);
    const [dataToEdit, setDataToEdit] = useState(deepClone(props.data));
    
    const [isDisable, setDisable] = useState(moment().add(30, "day").isAfter(moment(dataToEdit.dueDate)) || (props.data.appraiseeProgressCount ? true:false))
    let fromRowIndex = null;
    let toRowIndex = null;
    const validMaxLength = 500;
    useEffect(() => {
        
        let storedSequence = props.data.questions;
        storedSequence = storedSequence.sort((q1, q2) => q1.seq - q2.seq)
        storedSequence?.forEach(module => {
            sequence.push({ ...module, visible: module.visible != null ? module.visible : true });
        });
        setSequence([...sequence]);
    }, [])

    
    const toggleShowCard = (index) => {
        if(sequence[index]) {
            sequence[index].visible = !sequence[index].visible;
            setSequence([...sequence]);
            if (props.onSequenceChange) {
                props.onSequenceChange(sequence);
            }
        }
        
    }

    const onDragStart = (e, rowIndex) => {
        e.dataTransfer.dropEffect = "move";
        fromRowIndex = rowIndex;
    };

    const onCardDragOver = (e, rowIndex) => {
        e.preventDefault();
    };
    const onCardDrop = (e, rowIndex) => {
        toRowIndex = rowIndex;
        const newSequence = [...sequence];
        const itemMoved = newSequence.splice(fromRowIndex, 1)[0];
        newSequence.splice(toRowIndex, 0, itemMoved);
        setSequence(newSequence);
        if (props.onSequenceChange) {
            props.onSequenceChange(newSequence);
        }
        e.preventDefault();
    };
    const isRequired = (validation) => {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }
    const onAddNewQuestion=()=>{
        if(isDisable) {
            return
        }
        const newSequence = [
            ...sequence,
            {
                "question": "",
                "description":"",
                "appraiser": true,
                "selfAssessment": true
            }
        ]
        setSequence(newSequence)
    }
    const showError = (errorMessage) => {
        if (errorMessage) {
            return (
                <DKLabel
                    className="p-h-xl ml-xs fs-s text-red"
                    text={errorMessage}
                />
            )
        }
    }
    const isValidForm=()=>{
        let inValid = sequence.find(s=>s?.question?.length > validMaxLength || Utility.isEmpty(s?.question?.trim()))
        return !inValid
    }
    const onNext = () => {
        if(isDisable) {
            return;
        }
        let appraisalDataForEdit = AppraisalManager.getAppraisalData();
        setValidate(true)
        if(!isValidForm()) {
            showToast('Please fill the valid data', TOAST_TYPE.FAILURE);
            return
        }
        let param = {
            ...appraisalDataForEdit,
            questions: sequence.map((s,ind)=>{return {...s,seq:ind}})
        }
        showLoader(t("UPDATING_PERFORMANCE_SETTINGS"));
            PerformaceService.updateAppraisalCycle(appraisalDataForEdit.id, param).then(
                (response) => {
                    removeLoader();
                    showToast(t("SAVE_PERFORMANCE_SETTINGS_SUCCESS"), TOAST_TYPE.SUCCESS);
                    AppraisalManager.setAppraisalData(null)
                    props.onCancel()
                }, (error) => {
                    removeLoader();
                    if (error?.errorMessage) {
                        
                        showAlert('Appraisal can not be updated.', error.errorMessage)
                    } else {
                        showToast(t("INTERNAL_SERVER_ERROR"), TOAST_TYPE.FAILURE);
                    }

                }
            );
    }
    const getMaxLengthValue = (validation) => {
        return validation ? validation.find((v) => v[0] === "maxLength")?.[1] : false;
    }
    const onRemoveQuestion = (index) => {
        if(isDisable) {
            return;
        }
        const newSequence = sequence.splice(index, 1);
        setSequence([...sequence]);
    }

    const showValueLength = (field) => {
        return (
            <DKLabel
                className="p-h-s pt-s text-align-right"
                text={`${field.value?.length || 0}/${getMaxLengthValue(field.validation)}`}
            />
        );
    }
    const getQuestionCard = () => {
        return <div className={"column z-index-1  parent-width align-items-stretch position-relative"}>
            {sequence != null && sequence?.map((module, rowIndex) => {
                return <div key={module.id}
                    id={`row-${rowIndex}`}
                    className="p-m mb-s bg-white border-m border-gray fs-m cursor-move"
                    onClick={() => toggleShowCard(rowIndex)}
                    draggable
                    onDragStart={(e) => onDragStart(e, rowIndex)}
                    onDragOver={(e) => onCardDragOver(e, rowIndex)}
                    onDrop={(e) => onCardDrop(e, rowIndex)}
                >
                    <div className="d-flex">
                        <DKIcon className="ic-s mr-m" src={ic_drag}/>
                        <DKLabel className="fw-m" text={`Question `} />
                        {/* ${module.seq} */}
                    </div>
                    
                    <div className="row mt-m" style={{gap: 16}}>
                    {questionField({
                        id: `question${rowIndex}`,
                        title: `Question`,
                        type: INPUT_TYPE.LONG_TEXT,
                        showValueLength: true,
                        validMaxLength: validMaxLength,
                        validation: [["required"], ["maxLength", validMaxLength]],
                        value: module.question,
                        key: 'question',
                        index: rowIndex
                    })}
                    {questionField({
                        id: `question${rowIndex}`,
                        title: `Description`,
                        type: INPUT_TYPE.LONG_TEXT,
                        showValueLength: true,
                        validMaxLength:validMaxLength,
                        validation: [["maxLength", validMaxLength]],
                        value: module.description,
                        key: 'description',
                        index: rowIndex
                    })}
                    <div className="column" style={{ width: '30%', rowGap:20 }}>
                    {questionField({
                        id: `question${rowIndex}`,
                        title: `Self Assessment`,
                        type: INPUT_TYPE.CHECKBOX,
                        showValueLength: true,
                        validation: [["required"], ["maxLength", 300]],
                        value: module.selfAssessment,
                        key: 'selfAssessment',
                        index: rowIndex
                    })}
                    {questionField({
                        id: `question${rowIndex}`,
                        title: `Appraiser`,
                        type: INPUT_TYPE.CHECKBOX,
                        showValueLength: true,
                        validation: [["required"], ["maxLength", 300]],
                        value: module.appraiser,
                        key: 'appraiser',
                        index: rowIndex
                    })}
                    </div>
                    <DKIcon className={`${isDisable ? "cursor-not-allowed":"cursor-hand "} ic-s`} src={DKIcons.ic_delete} onClick={()=>onRemoveQuestion(rowIndex)}/>
                    </div>
                </div>
            })}
        </div>
    }
    const questionField = (field) => {
        return <div style={{ width: field.type !== INPUT_TYPE.CHECKBOX ?"30%":"100%" }}>
            {(field.type !== INPUT_TYPE.CHECKBOX) && 
            <div className="  p-h-xl position-relative appraisal-cycle"><DKInput
                title={field.title}
                type={field.type}
                validator={(value)=>{
                    field.isValid =  value.length <= validMaxLength && !Utility.isEmpty(value.trim())
                    return field.isValid
                }}
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                value={field.value}
                errorMessage={field.errorMessage}
                readOnly={isDisable}
                required={isRequired(field.validation)}
                invalid={field.invalid}
                canValidate={sequence[field.index]['canValidate'] || canValidate}
                onChange={(value) => {
                    field.value = value;
                    field.canValidate = true;
                    let newsequence = deepClone(sequence)
                    newsequence[field.index]['canValidate'] = true;
                    newsequence[field.index][field.key] = value
                    setSequence(newsequence)
                    
                }}
            />
            
            {showValueLength(field)}
            </div>}
            {field.type === INPUT_TYPE.CHECKBOX && (
                <div className={`row ${isDisable ? "cursor-not-allowed":"cursor-hand"}`} onClick={() => {
                    if(isDisable) {
                        return
                    }
                    field.value = field.value ? false:true;
                    let newsequence = sequence
                    newsequence[field.index][field.key] = newsequence[field.index][field.key] ? false:true
                    setSequence(newsequence)
                    
                }} >
                    <DKCheckMark
                        isSelected={field.value}
                        color={`${isDisable ? "border-m disable-button bg-gray cursor-not-allowed" :"bg-app"}` }
                    />
                    <DKLabel className="ml-s fw-s" text={field.title} />
                </div>
            )}
        </div>
    }
    return <>
        <DKLabel className="fw-m fs-m mb-m" text="Add questions in appraisal" />
        {getQuestionCard()}
        <DKButton disabled={isDisable} className={`${isDisable ? "bg-gray border-gary cursor-not-allowed  border-m":"bg-app "} text-white  d-inline-flex mt-m`} title="+ Add Question" onClick={()=>{onAddNewQuestion()}}/>
        <div className="row mt-l">
                <DKButton disabled={isDisable} className={isDisable ? "bg-gray border-gary cursor-not-allowed  border-m text-white":"bg-app text-white"} title="Save and Initialize" onClick={()=>onNext()}/>
                <DKButton className="bg-white border-m ml-m" title="Back" onClick={()=>props.onBack()}/>
                <DKButton className="bg-white border-m ml-m" title="Cancel" onClick={()=>props.onCancel()}/>
        </div>
    </>
}

export default AppraisalCycleQuestions